
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexo4kZsUXyL2R6UeZFexICtGVhaCUQb8of2u2SU3nZgvoMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/lp/pages/index.vue?macro=true";
import { default as signin0ODj_45GA4qhUanHEQqw8m44LilsLwMENKfAYOnf2N7DQMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/signin.vue?macro=true";
import { default as signupHSMUofRNm6E4W2CQZQApy9ob3Y0xp3sMW6fO7MZebUwMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/signup.vue?macro=true";
import { default as homeTknU_UfrfSR9mVhBqOBIxNQd0s6yOHxHGuuIRPduF5gMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/home.vue?macro=true";
import { default as confirm_45accountakXs_FnT0NSA_26bgIgefouFQFoECcNBoN4_45xXca1OcMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/confirm-account.vue?macro=true";
import { default as forgot_45password7qwgXYrMNjfeuBPfdhIhnBpBg1Xg5EQcHfyf3y_Q_44Meta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/forgot-password.vue?macro=true";
import { default as indexPCopaqMUlZPNnY3j3WfqdPTTWJuajFSn24kZeGyN1FQMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/profile/index.vue?macro=true";
import { default as session_45expiredFayQZLjdje7h_45YWnBot3kwPpsb6xy84qx8oQpDHHRL4Meta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/session-expired.vue?macro=true";
import { default as indexwx288u08HkVZJOL8MMDcbQBm6cFHZRmekCds3J3h_45_45IMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/workspace/index.vue?macro=true";
import { default as securityFi1CHwfVyUe9fKP6uMEr_X00JVmk099UWFXTluIcAgQMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/profile/security.vue?macro=true";
import { default as createkLYvkqADVuRsoePJ9HbmZS_XfOSMbohCaPok8DUi6_0Meta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/workspace/create.vue?macro=true";
import { default as confirm_45invitationhSwM5WDRN_g2RwpHjH6OjVd3tyFA9TMDlyw167Rqy8kMeta } from "/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/confirm-invitation.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexo4kZsUXyL2R6UeZFexICtGVhaCUQb8of2u2SU3nZgvoMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/lp/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: { ...(signin0ODj_45GA4qhUanHEQqw8m44LilsLwMENKfAYOnf2N7DQMeta || {}), ...{"middleware":["unauthenticated-only"]} },
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupHSMUofRNm6E4W2CQZQApy9ob3Y0xp3sMW6fO7MZebUwMeta || {}), ...{"middleware":["unauthenticated-only"]} },
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/signup.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeTknU_UfrfSR9mVhBqOBIxNQd0s6yOHxHGuuIRPduF5gMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/home.vue")
  },
  {
    name: "confirm-account",
    path: "/confirm-account",
    meta: { ...(confirm_45accountakXs_FnT0NSA_26bgIgefouFQFoECcNBoN4_45xXca1OcMeta || {}), ...{"middleware":["unauthenticated-only"]} },
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/confirm-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45password7qwgXYrMNjfeuBPfdhIhnBpBg1Xg5EQcHfyf3y_Q_44Meta || {}), ...{"middleware":["unauthenticated-only"]} },
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(auth)/forgot-password.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexPCopaqMUlZPNnY3j3WfqdPTTWJuajFSn24kZeGyN1FQMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/profile/index.vue")
  },
  {
    name: "session-expired",
    path: "/session-expired",
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/session-expired.vue")
  },
  {
    name: "workspace",
    path: "/workspace",
    meta: indexwx288u08HkVZJOL8MMDcbQBm6cFHZRmekCds3J3h_45_45IMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/workspace/index.vue")
  },
  {
    name: "profile-security",
    path: "/profile/security",
    meta: securityFi1CHwfVyUe9fKP6uMEr_X00JVmk099UWFXTluIcAgQMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/profile/security.vue")
  },
  {
    name: "workspace-create",
    path: "/workspace/create",
    meta: createkLYvkqADVuRsoePJ9HbmZS_XfOSMbohCaPok8DUi6_0Meta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/workspace/create.vue")
  },
  {
    name: "confirm-invitation",
    path: "/confirm-invitation",
    meta: confirm_45invitationhSwM5WDRN_g2RwpHjH6OjVd3tyFA9TMDlyw167Rqy8kMeta || {},
    component: () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/pages/(plataform)/confirm-invitation.vue")
  }
]